import React, { Component, PropTypes } from 'react'
import Header from './header'
import Progress from '../containers/progress'
import {
    formHandler,
    CategorisedMultipleCheckbox,
    Select,
    Button,
} from './ui'

export default class CrewPositions extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        actions: PropTypes.shape({
            loadPersonal: PropTypes.func.isRequired,
            updateCrewPositions: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        crew: PropTypes.shape({
            crew_types: PropTypes.array,
        }).isRequired,
        crew_actions: PropTypes.shape({
            loadCrewTypes: PropTypes.func.isRequired,
        }).isRequired,
        personal: PropTypes.shape({
            data: PropTypes.object,
            errors: PropTypes.object,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: this.normalisePersonalData(props.personal.data),
        }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this.props.personal.data) {
            this.props.actions.loadPersonal(this.props.account.user.crew.uuid)
        }
        if (! this.props.crew.crew_types) {
            this.props.crew_actions.loadCrewTypes()
        }
    }

    componentWillReceiveProps(nextProps) {
        // Update the state data when we receive new personal data props
        if (nextProps.personal && ! (
            this.props.personal &&
            nextProps.personal.data === this.props.personal.data
        )) {
            this.setState({
                data: this.normalisePersonalData(nextProps.personal.data),
            })
        }
    }

    submitForm = () => {
        const data = { ...this.state.data }

        // see if the special fields we care about have "none" values and, if
        // so, manipulate the values a little
        if (data.hasOwnProperty('crew_secondary_type')) {
            if (data.crew_secondary_type === 'N/A') {
                data.crew_secondary_type = null
                data.crew_secondary_type_none = true
            } else {
                data.crew_secondary_type_none = false
            }
        }
        if (data.hasOwnProperty('crew_tertiary_type')) {
            if (data.crew_tertiary_type === 'N/A') {
                data.crew_tertiary_type = null
                data.crew_tertiary_type_none = true
            } else {
                data.crew_tertiary_type_none = false
            }
        }

        this.props.actions.updateCrewPositions(data)
    }

    /**
     * Normalise and filter personal data to only inlude the properties we care about and in the format we require.
     *
     * @param {Object} data The data to be normalised.
     * @return {Object} The normalised data
     */
    normalisePersonalData(data) {
        const newData = {}

        if (data) {
            newData.uuid = data.uuid

            if (data.type) {
                newData.type = data.type
            }

            if (data.crew_secondary_type) {
                newData.crew_secondary_type = data.crew_secondary_type
            } else {
                if (data.crew_secondary_type_none === true) {
                    newData.crew_secondary_type = 'N/A'
                }
            }

            if (data.crew_tertiary_type) {
                newData.crew_tertiary_type = data.crew_tertiary_type
            } else {
                if (data.crew_tertiary_type_none === true) {
                    newData.crew_tertiary_type = 'N/A'
                }
            }

            // get add additional crew types into the new data
            newData.additional_crew_type = data.additional_crew_type
        }

        return newData
    }

    crewTypeOptions(addBlank = false) {
        const options = this.props.crew.crew_types ? [ ...this.props.crew.crew_types ] : []

        // prepend with a blank option if required
        if (addBlank === true) {
            options.unshift({
                value: 'N/A',
                label: 'Not applicable',
                category: null,
            })
        }

        return options
    }

    render() {
        if (! this.state.data) {
            return null
        }
        if (! this.props.crew.crew_types) {
            return null
        }

        const errors = this.props.personal.errors

        return (
            <div>
                <Header title="Crew Positions" />

                <div className="content">
                    <Progress stage="crew-positions" />

                    <div className="content__inner">
                        <div className="alert" style={{ background: '#ebebeb', color: '#555', fontWeight: 'bold' }}>
                            <p>
                                This section is used to help us determine what crew positions you
                                want to be hired for. Your crew position selection should be based
                                on your professional work experience and gear knowledge and
                                ownership. Please only select positions for which you qualify as a
                                professional crew member. Based on your choices, each position will
                                have a follow up questionnaire about your gear knowledge, ownership,
                                and additional technical production experience.
                            </p>
                            <p>
                                Only a PRIMARY crew position is required.
                            </p>
                            <p>
                                We encourage you to select as many crew positions as you see fit and
                                want to be called on for potential production work.
                            </p>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Primary Position
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <Select
                                    categoriseBy="category.label"
                                    error={ errors.type }
                                    name="type"
                                    options={ this.crewTypeOptions() }
                                    placeholder="Primary crew type"
                                    updateValue={ this.updateValue }
                                    value={ this.state.data.type }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Secondary Position
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <Select
                                    categoriseBy="category.label"
                                    error={ errors.crew_secondary_type }
                                    name="crew_secondary_type"
                                    options={ this.crewTypeOptions() }
                                    placeholder="Secondary crew type"
                                    updateValue={ this.updateValue }
                                    value={ this.state.data.crew_secondary_type }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Tertiary Position
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <Select
                                    categoriseBy="category.label"
                                    error={ errors.crew_tertiary_type }
                                    name="crew_tertiary_type"
                                    options={ this.crewTypeOptions() }
                                    placeholder="Tertiary crew type"
                                    updateValue={ this.updateValue }
                                    value={ this.state.data.crew_tertiary_type }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Additional crew positions
                                </div>
                            </div>
                            <div className="box__content">
                                <CategorisedMultipleCheckbox
                                    categoriseBy="category.label"
                                    error={ errors.additional_crew_type }
                                    name="additional_crew_type"
                                    options={ this.crewTypeOptions() }
                                    updateValue={ this.updateValue }
                                    value={ this.state.data.additional_crew_type }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="submit-row">
                    <Button
                        buttonOnly
                        loading={ this.props.appState.loading || ! this.props.personal.data }
                        onClick={ this.submitForm }
                        status="primary"
                    >
                        Save
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/crew_positions.js